export default function (context, {value, name}) {
    let i = 0;
    value.forEach(item => {
        item.index = i;
        i++;
    });
    context.state[name].rebind = false;
    setTimeout(() => {
        context.state.rebind = true;
    });
}